// material-ui
import Box from '@mui/material/Box';

// project imports
import logo from 'assets/images/logo.png';

// ==============================|| LOGO — ICON ONLY (collapsed sidebar) ||============================== //

export default function LogoIcon() {
  return <Box component="img" src={logo} alt="" sx={{ width: '100%', height: '100%', borderRadius: 1.5, display: 'block' }} />;
}
